module.exports = __webpack_public_path__ + "img/17_74.d7d3a91a.png";